<template>
    <div ref="billProductTableDom">
        <el-table :data="tableData">
            <el-table-column prop="productname" :label="i18n.tkey('lang_product_name')" />

            <el-table-column :label="i18n.tkey('lang_unit_price')" >
                <template #default="scope">
                    <div style="">
                        <span>{{ scope.row.cost }} {{ scope.row.curr }}</span>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="qty" :label="i18n.tkey('lang_buy_num')" />

            <el-table-column prop="date" :label="i18n.tkey('lang_total_price_num')" >
                <template #default="scope">
                    <div style="">
                        <span>{{ scope.row.subtotal }} {{ scope.row.curr }}</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script setup>
    import {onMounted, ref, getCurrentInstance, inject} from "vue";

    const props = defineProps(["boproducts"])

    const i18n = inject("i18n")

    const width = ref(425)
    const cols = ref(24)
    const { proxy } = getCurrentInstance()
    const tableData = ref([])

    onMounted(() => {
        width.value = proxy.$refs.billProductTableDom.offsetWidth

        if (width.value > 768){
            cols.value = 12
        }

        tableData.value = props.boproducts
    })
</script>

<style scoped>

</style>